import React from 'react';
import { Calendar, CreditCard } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { createStripeCheckout } from '../utils/stripe';

const BookMeeting = () => {
  return (
    <section className="py-24 px-6 bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50">
      <div className="max-w-4xl mx-auto">
        <Card className="p-12 bg-white shadow-2xl border-2 border-orange-200">
          <div className="text-center space-y-8">
            <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-rose-500 rounded-full flex items-center justify-center mx-auto shadow-lg">
              <Calendar className="h-10 w-10 text-white" />
            </div>
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900">
                Book a 1-on-1 Meeting with Me
              </h2>
              <p className="text-2xl font-bold text-orange-600">$30 per hour</p>
            </div>
            <div className="space-y-4">
              <Button 
                onClick={() => createStripeCheckout('1-on-1 Meeting (1 Hour)', 'consultation', 30, 'usd')}
                className="bg-gradient-to-r from-orange-500 to-rose-500 hover:from-orange-600 hover:to-rose-600 text-white px-10 py-7 text-lg font-semibold shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
              >
                <CreditCard className="mr-3 h-6 w-6" />
                Pay $30 & Schedule Your Meeting
              </Button>
              <p className="text-sm text-gray-500 mt-4">
                After payment, you'll receive a confirmation email with scheduling details.
              </p>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default BookMeeting;